import { KYMW1403Component } from './kymw1403.component';

/**
 * 掲載商品検索画面の値を管理するクラス
 *
 * @export KYMW1403Model
 * @class KYMW1403Model
 */
export class KYMW1403Model {

  kymw1403Component: KYMW1403Component = null;

  /**
   * 検索結果格納用Array
   */
  public publishGoodsArray: Array<any> = null;

  /**
   * 総件数
   */
  // 項番2231 START 障害管理NO.U01451対応
  public totalNum = Number(0);
  // 項番2231 END 障害管理NO.U01451対応

  /**
   * 開始件数
   */
  // 項番2231 START 障害管理NO.U01451対応
  public startDispNum = Number(0);
  // 項番2231 END 障害管理NO.U01451対応

  /**
   * 終了件数
   */
  // 項番2231 START 障害管理NO.U01451対応
  public endDispNum = Number(0);
  // 項番2231 END 障害管理NO.U01451対応

  // 受注コード(From)
  public orderCodeFrom = String('');
  // 受注コード(To)
  public orderCodeTo = String('');
  // 商品案内用商品名
  public guideGoodsName = String('');
  // Pコード
  public pCode = String('');

  public chbIbaraki = Boolean(false);
  public chbTochigi = Boolean(false);
  public chbGunma = Boolean(false);
  public chbChiba = Boolean(false);
  public chbSaitama = Boolean(false);
  public chbTokyo = Boolean(false);
  public chbNagano = Boolean(false);
  public chbNiigata = Boolean(false);
  public chbKuruco = Boolean(false);

  // 非活性フラグ
  public disabledPreviousButton = Boolean(true);
  public disabledNextButton = Boolean(true);

  // 項番2231 START 課題管理NO.14対応
  public sortOrder = String('');
  public sortKey = String('');
  // 項番2231 END 課題管理NO.14対応

  /**
   * 掲載商品検索の結果を表示する
   *
   * @param {*} serverData サーバからの受信データ
   * @memberof KYMW1403Model
   */
  public updateServerResponse(serverData: any): void {
    // 作業用変数定義
    const tempPublishGoodsArray: Array<any> = new Array<any>();
    let tempPublishGoodsData: any = null;

    // 第一階層(総件数・開始件数・終了件数)の設定
    this.totalNum = Number(serverData.TotalNum);	        // 総件数
    this.startDispNum = Number(serverData.StartDispNum);	// 開始件数
    this.endDispNum = Number(serverData.EndDispNum);	    // 終了件数

    // 検索結果の格納を行う
    if (serverData.PublishGoodsData != null) {
      // 検索結果が複数存在する場合は、ループしてすべてのデータを設定する
      for (let i = Number(0); i < serverData.PublishGoodsData.length; i++) {
        tempPublishGoodsData = new Object();
        tempPublishGoodsData.OrderCode = this.nullTOEmpty(serverData.PublishGoodsData[i].OrderCode);
        tempPublishGoodsData.DelivCatalogId = this.nullTOEmpty(serverData.PublishGoodsData[i].DelivCatalogId);
        tempPublishGoodsData.MediumType = this.nullTOEmpty(serverData.PublishGoodsData[i].MediumType);
        tempPublishGoodsData.MediumName = this.nullTOEmpty(serverData.PublishGoodsData[i].MediumName);
        tempPublishGoodsData.CoopCode = this.nullTOEmpty(serverData.PublishGoodsData[i].CoopCode);
        tempPublishGoodsData.PlanCoopName = this.nullTOEmpty(serverData.PublishGoodsData[i].PlanCoopName);
        tempPublishGoodsData.PageId = this.nullTOEmpty(serverData.PublishGoodsData[i].PageId);
        tempPublishGoodsData.PageNum = this.nullTOEmpty(serverData.PublishGoodsData[i].PageNum);
        tempPublishGoodsData.PageInfo = this.nullTOEmpty(serverData.PublishGoodsData[i].PageInfo);
        tempPublishGoodsData.Pcode = this.nullTOEmpty(serverData.PublishGoodsData[i].Pcode);
        tempPublishGoodsData.GuideGoodsName = this.nullTOEmpty(serverData.PublishGoodsData[i].GuideGoodsName);
        tempPublishGoodsData.GuideStandardName = this.nullTOEmpty(serverData.PublishGoodsData[i].GuideStandardName);

        // 作業用配列に追加
        tempPublishGoodsArray.push(tempPublishGoodsData);
      }
    }

    // 作業用配列を現在の配列に書き換え
    this.publishGoodsArray = tempPublishGoodsArray;
  }

  /**
   * NULLデータを表示用に空白に変換
   *
   * @private
   * @param {*} obj
   * @returns {object}
   * @memberof KYMW1403Model
   */
  private nullTOEmpty(obj: any): object {
    if (obj == null) {
      return Object('');
    } else {
      return obj;
    }
  }
}
